module.exports = __webpack_public_path__ + "img/no_internet_light.0f71ea3a.svg";